export const SEARCH_ROUTE = "/{service_company_slug}/search/"
